export default __webpack_public_path__ + "static/static-asset-UK-78e6a90fc83bc3e1a87620c75a625863.svg";